module.exports = __webpack_public_path__ + "img/scorpion-logo.f5c55e94.svg";